import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { ReportIncomeEventType } from './report-income.event.type';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EventTypes } from './../../shared/EventTypes';
import { ReportIncomeModel } from './models/report-income';

@Component({
	selector: 'app-report-income',
	templateUrl: './report-income.component.html',
	styleUrls: ['./report-income.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ReportIncomeComponent implements OnInit, OnDestroy {

	public title = 'Informe de rendimentos';
	private form: FormGroup;
	hasSubmited = false;
	activeBackButton = false;
	showStepButtons = false;

	public reportIncomeData = new ReportIncomeModel();

	constructor() { }

	ngOnInit() {
		this.show();
	}

	show() {
		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(ReportIncomeEventType.STEPS.REPORT_INCOME_LIST, { show: true });
		});

		AppEventDispatcher.listen(ReportIncomeEventType.BUTTONS, data => {
			if (data.show) {
				this.showStepButtons = true;
				TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
				TweenMax.delayedCall(.6, () => {
					this.activeBackButton = data.activeBackButton ? data.activeBackButton : false;
					TweenMax.delayedCall(.2, () => {
						TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
					});
				});
			} else {
				this.showStepButtons = false;
			}

		});
	}

	onSetForm(form: FormGroup) {
		this.form = form;
	}

	onSetTitle(data) {
		this.title = data.title;
	}

	sendForm(event) {
		this.hasSubmited = true;

		if (this.form.valid) {

			this.hasSubmited = false;

			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { hide: true });
			AppEventDispatcher.dispatch(ReportIncomeEventType.REPORT_INCOME.CONFIRM_DATA, {});
		}
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ReportIncomeEventType.STEPS.REPORT_INCOME_LIST);
		AppEventDispatcher.removeListener(ReportIncomeEventType.ERROR);
		AppEventDispatcher.removeListener(ReportIncomeEventType.BUTTONS);
	}

	public onShowStepButtons(value: boolean) {
		this.showStepButtons = value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/report-income/report-income.component.ts